const learningStylesData = {
  qs: [
    {
      q: "I can focus best on my work when:",
      opts: {
        "It is quiet": "Visual",
        "There is soft music": "Auditory",
        "I am able to move around": "Physical",
        "I am able to talk with others": "Verbal",
        "I am given clear rules and structure": "Logical",
      },
    },
    {
      q: "When studying for a test, I would rather:",
      opts: {
        "Read notes, reread the textbook, and look at diagrams and pictures":
          "Visual",
        "Have someone quiz me or repeat facts aloud to myself": "Auditory",
        "Write things out on index cards or use flashcards": "Physical",
        "Re-write information in my own words or join a study group": "Verbal",
        "Identify how things are connected and use mind maps": "Logical",
      },
    },
    {
      q: "Which of these do you do when you listen to music?",
      opts: {
        "Daydream, seeing images and scenes that go along with the music":
          "Visual",
        "Hum or sing along": "Auditory",
        "Move with the music": "Physical",
        "Concentrate on the lyrics and the message of the song": "Verbal",
        "I think about music theory or count rhythms": "Logical",
      },
    },
    {
      q: "When solving a difficult math problem, do you:",
      opts: {
        "Draw a picture, make a diagram, or even close your eyes to try to see the problem":
          "Visual",

        "Talk to classmates, the teacher, or a parent to formulate your ideas":
          "Auditory",

        "Build a model of the problem with something like blocks to solve":
          "Physical",
        "Re-read the textbook to remember the process of how to solve":
          "Verbal",

        "Make a list, organize the steps, and check them off as they are done":
          "Logical",
      },
    },
    {
      q: "To learn how a computer program works, would you rather:",
      opts: {
        "Watch a video about it": "Visual",
        "Listen to someone explain it": "Auditory",
        "Dive in and try to figure it out yourself": "Physical",
        "Read the manual or directions": "Verbal",
        "Gather all the information so I can really understand how it works":
          "Logical",
      },
    },
    {
      q: "You enter a science museum. What do you do first?",
      opts: {
        "Look around and try to find a map": "Visual",
        "Talk to a museum guide or sign up for a tour": "Auditory",
        "Start walking around and looking at the exhibits": "Physical",
        "Find a brochure that explains information about the museum and what is offered":
          "Verbal",
        "Make a plan or agenda that would allow you to see all the exhibits you want to see in the amount of time that you have":
          "Logical",
      },
    },
    {
      q: "If you go to a gathering with lots of new people, the next day would you most likely remember:",
      opts: {
        "The faces of people, but not their names": "Visual",
        "The names of people, but not their faces": "Auditory",
        "The things that you did while you were there": "Physical",
        "The conversations that you had": "Verbal",
        "How the party was set up and how the decorations helped to convey the theme":
          "Logical",
      },
    },
    {
      q: "What is the most distracting for you when you are trying to concentrate?",
      opts: {
        "Visual distractions": "Visual",
        Noises: "Auditory",
        "Hunger, tight shoes, or an uncomfortable chair": "Physical",
        Talking: "Verbal",
        "Time limits": "Logical",
      },
    },
    {
      q: "If you are not sure how to spell a word, what are you most likely going to do?",
      opts: {
        "Write it out to see if it looks right": "Visual",
        "Sound it out": "Auditory",
        "Write it out and see if it feels right": "Physical",
        "Spelling is not your strong suit so you will just look it up":
          "Verbal",
        "Think of a similar word that I do know how to spell and use that word to help me figure it out":
          "Logical",
      },
    },
    {
      q: "If you have some free time, you would most like to:",
      opts: {
        "Watch a movie": "Visual",
        "Listen to some music": "Auditory",
        "Get outside and play": "Physical",
        "Have a conversation with someone close to you": "Verbal",
        "Play a logic or strategy game": "Logical",
      },
    },
    {
      q: "Would you rather go to:",
      opts: {
        "An art class": "Visual",
        "A music class": "Auditory",
        "A sport, martial, art, or exercise class": "Physical",
        "A language class": "Verbal",
        "An escape room": "Logical",
      },
    },
    {
      q: "I learn well when I:",
      opts: {
        "Listen and watch": "Visual",
        "Talk to other people and get their ideas": "Auditory",
        "Use hands-on materials": "Physical",
        "Read about things": "Verbal",
        "Use the computer": "Logical",
      },
    },
    {
      q: "I prefer to learn",
      opts: {
        Alone: "Solitary",
        "With a partner": "Social",
        "With a small group": "Social",
        "As a whole class": "Social",
      },
    },
    {
      q: "When given the choice, I prefer participating in:",
      opts: {
        "Team sports and games with others": "Social",
        "Activities alone and away from others": "Solitary",
      },
    },
    {
      q: "I prefer:",
      opts: {
        "The company of my own thoughts": "Solitary",
        "To not hear other's feelings and opinions": "Solitary",
        "To participate in class discussions and group projects": "Social",
        "To be involved in as many group activities as I can": "Social",
      },
    },
  ],
  s: {
    Auditory: {
      Solitary: {
        p1: "Your child is a solitary and auditory learner, meaning that they process information through sound, learn best from listening, are highly independent, and enjoy spending time alone.",
        cl: [
          "Closes their eyes to focus on sound",
          "Talks and moves their lips to process information",
          "Needs to listen and speak to learn",
          "Has excellent self-management skills",
          "Likes to set goals and make plans",
          "Does not benefit from noisy learning environments",
        ],
        p2: "At Growing IQ, students are encouraged to think out loud.  In class students are asked to justify both their answers and their thinking processes. This practice is highly beneficial for the auditory learner, as they learn bestfrom listeningand talking.An environment that is filled with the voices of the students enablesyour childto process new ideasand gain valuable insights from their peers.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From individual (the preferred way of the solitary learner) to collaborative (helping the solitary learner come out of their comfort zone), your child will engage with mathematical materialin ways that will help them to learn new and valuable social skills.",
      },
      Social: {
        p1: "Your child is a social and auditory learner, meaning that they process information through sound, learn best from listening, are not afraid to ask questions, and do well in collaborative activities.",
        cl: [
          "Closes their eyes to focus on sound",
          "Talks and moves their lips to process information",
          "Needs to listen, speak, and interact to learn",
          "Is good at interpreting tone, gestures, and facial expressions",
          "Is a natural leader",
          "Can struggle working alone",
        ],
        p2: "At Growing IQ, students are encouraged to think out loud.  In class students are asked to justify both their answers and their thinking processes. This practice is highly beneficial for the auditory learner, as they learn best from listening and talking.  An environment that is filled with the voices of the students enables your childto process new ideas and gain valuable insights from their peers.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From collaborative (the preferred way of the social learner) to individual (helping the social learner come out of their comfort zone),your child will engage with mathematical material in ways that help them to learn new and valuable intrapersonal skills.",
      },
    },
    Visual: {
      Solitary: {
        p1: "Your child is a solitary and visual learner, meaning that they process information through sight, learn best by watching, are highly independent, and enjoy spending time alone.",
        cl: [
          "Has a vivid imagination and thinks primarily in pictures",
          "Uses their intuition to solve problems",
          "Easily identifies patterns in what they see",
          "Has excellent self-management skills",
          "Likes to set goals and make plans",
          "Does not benefit from noisy learning environments",
        ],
        p2: "A text heavy curriculum is not ideal for the visual learner. At Growing IQ, students are provided with a multitude of opportunities to represent their learning in visual and creative ways. This practice is highly beneficial for the visual learner. By seeing their own ideas in conjunction with the ideasof their peers, your childis able to come to new understandingsof mathematical concepts.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From individual (the preferred way of the solitary learner) to collaborative (helping the solitary learner come out of their comfort zone), your child will engage with mathematical material in ways that will help them to learn new and valuable social skills.",
      },
      Social: {
        p1: "Your child is a social and visual learner, meaning that they process information through sight, learn best by watching, are not afraid to ask questions, and do well in collaborative activities.",
        cl: [
          "Has a vivid imagination and thinks primarily in pictures",
          "Uses their intuition to solve problems",
          "Easily identifies patterns in what they see",
          "Is good at interpreting tone, gestures, and facial expressions",
          "Is a natural leader",
          "Can struggle working alone",
        ],
        p2: "A text heavy curriculum is not ideal for the visual learner. At Growing IQ, students are provided with a multitude of opportunities to represent their learning in visual and creative ways. This practice is highly beneficial for the visual learner. By seeing their own ideas in conjunction with the ideas of their peers, your child is able to come to new understandings of mathematical concepts.",
        p3: "In addition, classes are formatted toprovide a variety of learning experiences. From collaborative (the preferred way of the social learner) to individual (helping the social learner come out of their comfort zone), your child will engage with mathematical material in ways that help them tolearn new and valuable intrapersonal skills.",
      },
    },
    Physical: {
      Solitary: {
        p1: "Your child is a solitary and physical learner, meaning that they process information physically, learn best from trying things themselves, are highly independent, and enjoy spending time alone.",
        cl: [
          "Are highly coordinated",
          "Are eager to take things apart and put them back together",
          "Needs to touch, move, and physically do to learn",
          "Has excellent self-management skills",
          "Likes to set goals and make plans",
          "Does not benefit from noisy learning environments",
        ],
        p2: "At Growing IQ, students are consistently exposed to hands-on activities using a wide variety of manipulatives and materials to actively engage them. This practice is highly beneficial for the physical learner.By creating learning experienceswhich are specifically focused on discovering the “why,”Growing IQ provides your child the opportunity to derive and discover mathematics.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From individual (the preferred way of the solitary learner) to collaborative (helping the solitary learner come out of their comfort zone), your child will engage with mathematical material in ways that will help them to learn new and valuable social skills.",
      },
      Social: {
        p1: "Your childis a solidary and physical learner, meaning that they process information physically, learn best from trying things themselves, are not afraid to ask questions, and do well in collaborative activities.",
        cl: [
          "Are highly coordinated",
          "Are eager to take things apart and put them back together",
          "Needs to touch, move, and physically do to learn",
          "Is good at interpreting tone, gestures, and facial expressions",
          "Is a natural leader",
          "Can struggle working alone",
        ],
        p2: "At Growing IQ, students are consistently exposed to hands-on activities using a wide variety of manipulatives and materials to actively engage them. This practice is highly beneficial for the physical learner.By creating learning experiences which are specifically focused on discovering the “why,” Growing IQ provides your child the opportunity to derive and discover mathematics.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From collaborative (the preferred way of the social learner) to individual (helping the social learner come out of their comfort zone), your child will engage with mathematical material in ways that help them to learn new and valuable intrapersonal skills.",
      },
    },
    Verbal: {
      Solitary: {
        p1: "Your child is a solitary and verbal learner, meaning that they process information through language, express themselves well with words, are highly independent, and enjoy spending time alone.",
        cl: [
          "Are fascinated with words and learn them easily",
          "Flourish in reading and writing activities",
          "Experience difficulty with spelling or visualizing information",
          "Has excellent self-management skills",
          "Likes to set goals and make plans",
          "Does not benefit from chaotic learning environments",
        ],
        p2: "At Growing IQ, communication is key. Students build skills as effective communicators by workingtogether and justify their thinking regularly to others. This practice is highly beneficial for the verballearnerwholikes to ask questions and participate in discussions. By engaging with peers, your child is given the opportunity to clarify their thinking and form a“big picture” understanding of mathematics.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From individual (the preferred way of the solitary learner) to collaborative (helping the solitary learner come out of their comfort zone), your child will engage with mathematical material in ways that will help them to learn new and valuable social skills.",
      },
      Social: {
        p1: "Your child is a solitary and verbal learner, meaning that they process information through language, express themselves well with words, are not afraid to ask questions, and do well in collaborative activities.",
        cl: [
          "Are fascinated with words and learn them easily",
          "Flourish in reading and writing activities",
          "Experience difficulty with spelling or visualizing information",
          "Is good at interpreting tone, gestures, and facial expressions",
          "Is a natural leader",
          "Can struggle working alone",
        ],
        p2: "At Growing IQ, communication is key. Students build skills as effective communicators by working together and justify their thinking regularly to others. This practice is highly beneficial for the verbal learner who likes to ask questions and participate in discussions. By engaging with peers, your child is given the opportunity to clarify their thinking and form a “big picture” understanding of mathematics.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From collaborative (the preferred way of the social learner) to individual (helping the social learner come out of their comfort zone), your child will engage with mathematical material in ways that help them to learn new and valuable intrapersonal skills.",
      },
    },
    Logical: {
      Solitary: {
        p1: "Your child is a solitary and logical learner, meaning that they process information through details, learn best from understanding how things work, are highly independent, and enjoy spending time alone.",
        cl: [
          "Is highly curious and investigative",
          "Is able to easily identify patterns",
          "Seeks out rules and procedures",
          "Has excellent self-management skills",
          "Likes to set goals and make plans",
          "Does not benefit from noisy learning environments",
        ],
        p2: "Growing IQ explores math concepts and allows students to develop their own conclusions based on experience. This practice is highly beneficial for the logical learner,as it capitalizes on their strong deductive reasoning abilities.By tinkeringand buildingabstract ideas, your child is given the opportunity to forge strong problem-solving skills.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences.  From individual (the preferred way of the solitary learner) to collaborative (helping the solitary learner come out of their comfort zone), your child will engage with mathematical material in ways that will help them to learn new and valuable social skills.",
      },
      Social: {
        p1: "Your child is a social and logical learner, meaning that they process information through details, learn best from understanding how things work, are not afraid to ask questions, and do well in collaborative activities.",
        cl: [
          "Is highly curious and investigative",
          "Is able to easily identify patterns",
          "Seeks out rules and procedures",
          "Is good at interpreting tone, gestures, and facial expressions",
          "Is a natural leader",
          "Can struggle working alone",
        ],
        p2: "Growing IQ explores math concepts and allows students to develop their own conclusions based on experience. This practice is highly beneficial for the logical learner, as it capitalizes on their strong deductive reasoning abilities. By tinkering and building abstract ideas, your child is given the opportunity to forge strong problem-solving skills.",
        p3: "In addition, classes are formatted to provide a variety of learning experiences. From collaborative (the preferred way of the social learner) to individual (helping the social learner come out of their comfort zone), your child will engage with mathematical material in ways that help them to learn new and valuable intrapersonal skills.",
      },
    },
  },
};

export { learningStylesData };
